import { CoreButton } from '@featuring-corp/components';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import InfluencerTable, {
	InfluencerTableProps,
} from '@components/report/influencer-table/InfluencerTable';

import { containerClass } from './style.css';

export type SimilarGroupYtProps<T extends string[]> = InfluencerTableProps<T>;

const SimilarGroupYt = <T extends string[]>(props: SimilarGroupYtProps<T>) => {
	const { t } = useTranslation('infReportYoutube');
	const available = !props.isLoading && !props.isError && !props.lackOfPermission;
	const [viewableSize, setViewableSize] = useState(5);

	const data = props.data ? props.data.slice(0, viewableSize) : [];

	return (
		<div className={containerClass}>
			<InfluencerTable
				header={[
					t(
						'features.report.section-content.yt.similar-group-yt.influencer-table.header.follower',
					),
					t(
						'features.report.section-content.yt.similar-group-yt.influencer-table.header.er',
					),
				]}
				{...props}
				data={data}
			/>
			{available && props.data?.length > viewableSize && (
				<CoreButton
					buttonType="tertiary"
					size="sm"
					text={t(
						'features.report.section-content.yt.similar-group-yt.influencer-table.button',
					)}
					onClick={() => setViewableSize(viewableSize + 5)}
				/>
			)}
		</div>
	);
};

export default SimilarGroupYt;
